<template>
  <main class="main profile-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="tab-list">
            <router-link to="/profile" class="item">Profile</router-link>
            <router-link to="/orders" class="item">Orders</router-link>
            <router-link v-if="this.$parent.offerEnabled" to="/offers" class="item">Offers</router-link>
            <div @click="$parent.logout" class="item">Log Out</div>
          </div>
          <div class="profile-table">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="profile-top">
                <div class="title small">Offers</div>
                <button class="button" @click="$parent.openSaleSkinModal">
                  <span>Sell skins</span>
                </button>
              </div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date</td>
                      <td>Skin name</td>
                      <td>Status</td>
                      <td>Total</td>
                      <td>Details</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.offerHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.date_time) }}</td>
                      <td>{{ item.title }}</td>
                      <td v-if="item.status == 'Accepted'" class="green">
                        <span class="status">{{ item.status }}</span>
                      </td>
                      <td v-else-if="item.status == 'Declined'" class="red">
                        <span class="status">{{ item.status }}</span>
                      </td>
                      <td v-else>
                        <span class="status">{{ item.status }}</span>
                      </td>
                      <td class="desc">
                        <b
                          >{{
                            item.service_price
                              ? item.service_price
                              : item.user_price
                          }}
                          {{ item.currency }}</b
                        >
                      </td>
                      <td>
                        <a
                          class="offer-modal-open desc link"
                          v-if="item.status == 'offer'"
                          @click="$emit('openOfferDetailsModal', item)"
                        >
                          <b>View</b>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  name: "SellOffers",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    formatToEST(timestamp) {
      if (!timestamp) return "";
      const momentObj =
        typeof timestamp === "number"
          ? moment.unix(timestamp)
          : moment(timestamp, "DD.MM.YYYY HH:mm");

      return momentObj.tz("Europe/Tallinn").format("DD.MM.YYYY HH:mm");
    },
  },
  computed: {
    ...mapGetters("app", ["currencySymbol", "currency"]),
  },
};
</script>

<style scoped>
.profile-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .profile-top {
    text-align: left;
    padding: 16px;
  }
}
</style>
